import axios from 'axios';
import { getToken } from '../functions/AuthenticationFunctions';

export const getHttpClient = url => {
    return axios.create({
        baseURL: url,
        headers: { 'Cache-Control': 'no-cache' }
    });
};

export function getApiError(err) {
    let error = {};
    if (err && err.response && err.response.data) {
        error = {
            code: err.response.data.code,
            message: err.response.data.message
        };
    } else {
        error = {
            code: 500,
            message: 'Unknown error occurred'
        }
    }

    return error;
}

export function getHeaders() {
    return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + getToken()
    };
}
